import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import businessTypeAPI from '../../apis/businessType'
import {withTranslation} from 'react-i18next'

class FormModal extends Component {
  formRef = React.createRef()

  handleOk = () => {
    const {handleCancel, handleSearch} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        businessType: fieldsValue.businessType
      }
      businessTypeAPI.addAction(params).then(() => {
        handleCancel()
        handleSearch()
      })

    }).catch()
  }

  render() {
    const {addModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`businessType.businessType`)}`}
          closable={false}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="businessType" label={t(`businessType.businessType`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`businessType.businessType`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
